import { Column } from "@/components/Datatable/types";
import { EventNotification } from "../../api/fetchEventNotifications/types";
import React from "react";
import { Switch } from "@/components/ui/switch";
import EventNotificationActionMenu from "../EventNotificationActionMenu/EventNotificationActionMenu";

interface EventNotificationsColumnsProps {
  onEditNotification: (id: number) => void;
  onToggleChannel: (
    notification: EventNotification,
    channel: "email" | "sms",
    enabled: boolean,
  ) => void;
}

export function eventNotificationsColumns({
  onEditNotification,
  onToggleChannel,
}: EventNotificationsColumnsProps): Column<EventNotification>[] {
  return [
    {
      header: "Name",
      accessorKey: "name",
      cell: ({ row }) => row.original.name,
    },
    {
      header: "Email Channel",
      accessorKey: "isMailChannelEnabled",
      cell: ({ row }) => {
        const notification = row.original;
        const handleChange = (checked: boolean) => {
          onToggleChannel(notification, "email", checked);
        };
        const stopPropagation = (evt: React.MouseEvent) => {
          evt.stopPropagation();
        };

        return (
          <Switch
            checked={notification.isMailChannelEnabled}
            onCheckedChange={handleChange}
            onClick={stopPropagation}
          />
        );
      },
    },
    {
      header: "SMS Channel",
      accessorKey: "isSmsChannelEnabled",
      cell: ({ row }) => {
        const notification = row.original;
        const handleChange = (checked: boolean) => {
          onToggleChannel(notification, "sms", checked);
        };
        const stopPropagation = (evt: React.MouseEvent) => {
          evt.stopPropagation();
        };

        return (
          <Switch
            checked={notification.isSmsChannelEnabled}
            onCheckedChange={handleChange}
            onClick={stopPropagation}
          />
        );
      },
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => (
        <EventNotificationActionMenu
          notificationId={row.original.id}
          onEditNotification={onEditNotification}
        />
      ),
    },
  ];
}
